import type {EntryPoint} from 'react-relay'
import {getRequest} from 'relay-runtime'

import {makeResource} from '../../../../utils/makeResource'
import {hasPipelinesQuery} from '../components/WelcomeScreen/WelcomeScreen.queries'

import type {IndexPageComponent} from './IndexPage'

export const IndexPageEntryPoint: EntryPoint<IndexPageComponent> = {
  root: makeResource(
    'IndexPage',
    () =>
      import(
        /* webpackChunkName: "IndexPage" */
        './IndexPage'
      ),
  ),
  getPreloadProps: () => ({
    queries: {
      hasPipelines: {
        parameters: getRequest(hasPipelinesQuery),
        variables: {},
        options: {networkCacheConfig: {metadata: {essential: true}}},
      },
    },
  }),
}
